

























































































































































































import { hexToRgb } from '@/utils/ChartUtils';
import { TileMultipleChoiceFrequencyOptions } from '@/utils/DashboardUtils';

import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Partial<TileMultipleChoiceFrequencyOptions>,
    },
  },

  computed: {
    styles() {
      return [
        {
          text: this.$tc(
            'model.dashboard.tile.multiple_choice_frequency.style.aggregate'
          ),
          value: 'aggregate',
        },
        {
          text: this.$tc(
            'model.dashboard.tile.multiple_choice_frequency.style.stack'
          ),
          value: 'stack',
        },
        {
          text: this.$tc(
            'model.dashboard.tile.multiple_choice_frequency.style.group'
          ),
          value: 'group',
        },
      ];
    },
  },

  beforeMount() {
    this.$emit('input', {
      xaxes: this.value?.xaxes || this.$languageobj(),
      yaxes: this.value?.yaxes || this.$languageobj(),
      style: this.value?.style || 'aggregate',
      questionkeys:
        this.value?.questionkeys?.map((questionkey) => ({
          key: questionkey.key,
          label: questionkey.label || this.$languageobj(),
          color:
            this.value?.style === 'stack' || this.value?.style === 'group'
              ? questionkey.color ||
                hexToRgb(this.$vuetify.theme.themes.light.primary as string)
              : undefined,
        })) || [],
      answers:
        this.value?.answers?.map((answerkey) => ({
          keys: answerkey.keys || [],
          label: answerkey.label || this.$languageobj(),
          color:
            this.value?.style === 'stack' || this.value?.style === 'group'
              ? undefined
              : answerkey.color ||
                hexToRgb(this.$vuetify.theme.themes.light.primary as string),
        })) || [],
    });
  },

  watch: {
    'value.style'(style: TileMultipleChoiceFrequencyOptions['style']) {
      for (const index in this.value.questionkeys) {
        this.value.questionkeys[index as any].color =
          style === 'stack' || style === 'group'
            ? hexToRgb(this.$vuetify.theme.themes.light.primary as string) ||
              undefined
            : undefined;
      }
      for (const index in this.value.answers) {
        this.value.answers[index as any].color =
          style === 'stack' || style === 'group'
            ? undefined
            : hexToRgb(this.$vuetify.theme.themes.light.primary as string) ||
              undefined;
      }
    },
  },

  methods: {
    addQuestionKey() {
      this.value.questionkeys?.push({
        key: '',
        label: this.$languageobj(),
        color: hexToRgb(this.$vuetify.theme.themes.light.primary as string),
      } as any);
    },

    removeQuestionKey(index: number) {
      this.value.questionkeys?.splice(index, 1);
    },

    addAnswer() {
      this.value.answers?.push({
        keys: [],
        label: this.$languageobj(),
        color: hexToRgb(this.$vuetify.theme.themes.light.primary as string),
      } as any);
    },

    removeAnswer(index: number) {
      this.value.answers?.splice(index, 1);
    },
  },
});
